/** @format */

import process from "process";
import { toast } from "react-toastify";
import i18n from "../Langues/i18n";
import { apiRequest } from "../Component/Utils/ApiHundler";

const API_BASE_URL = process.env.REACT_APP_API_URL;

/**
 * Met à jour les données pour une instance spécifique.
 * @param {string} token Le token d'authentification
 * @param {string} instanceId L'ID de l'instance à mettre à jour
 * @param {Object} updateData Les données à mettre à jour
 * @returns {Promise<Object>} Le résultat de l'appel d'API
 */
export async function updateInstanceData(
  token,
  instanceId,
  status,
  dDateRemise
) {
  const url = API_BASE_URL + "/process/update/";

  const data = await apiRequest(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify({
      InstanceId: instanceId,
      FieldList: {
        dDateRemise: dDateRemise,
        sStatus: status,
      },
    }),
  });

  toast.success(i18n.t('instanceUpdatedSuccess'));

  return data;
}